import { Dialog } from "@mui/material";
import { SexType } from "@notemeal/shared-utils-macro-protocol";
import DialogTitle from "apps/web/src/componentLibrary/DialogTitle";
import { useState } from "react";
import { invalidAge } from "shared-ui/MacroProtocol/utils";
import { AnthropometryEntryFragment, FullGoalFragment, FullMacroProtocolFragment, GoalTypeFragment } from "../../../types";
import MissingDataDialog from "../MissingDataDialog";
import { MacroProtocolEditModalContent } from "./Content";

interface MacroProtocolEditModalProps {
  athleteId: string;
  teamId?: string;
  initialMacroProtocol: FullMacroProtocolFragment;
  mostRecentAnthropometryEntry: AnthropometryEntryFragment | null;
  currentGoal: FullGoalFragment | null;
  athleteBirthdate: string | null;
  sex: SexType | null;
  goalTypes: readonly GoalTypeFragment[];
  open: boolean;
  onClose: () => void;
  refetchAmpData: () => void;
}

export const MacroProtocolEditModal = ({
  athleteId,
  teamId,
  initialMacroProtocol,
  mostRecentAnthropometryEntry,
  currentGoal,
  athleteBirthdate,
  sex,
  goalTypes,
  open,
  onClose,
  refetchAmpData,
}: MacroProtocolEditModalProps) => {
  const { leanBodyMass, percentBodyFat, height } = mostRecentAnthropometryEntry || {};
  const incompleteAnthropometry = !(leanBodyMass || percentBodyFat) || !height;
  const missingSex = !sex;
  const [dialogOpen, setDialogOpen] = useState(incompleteAnthropometry || !athleteBirthdate || missingSex);
  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
      <DialogTitle title="Edit Macronutrient Protocol" onClose={onClose} />
      {mostRecentAnthropometryEntry && (
        <MacroProtocolEditModalContent
          currentGoal={currentGoal}
          mostRecentAnthropometryEntry={mostRecentAnthropometryEntry}
          initialMacroProtocol={initialMacroProtocol}
          goalTypes={goalTypes}
          athleteBirthdate={athleteBirthdate}
          sex={sex}
          onClose={onClose}
          refetchAmpData={refetchAmpData}
        />
      )}
      <MissingDataDialog
        athleteId={athleteId}
        open={dialogOpen}
        onContinue={() => setDialogOpen(false)}
        onClose={onClose}
        noAnthropometry={mostRecentAnthropometryEntry === null}
        noBirthdate={athleteBirthdate === null}
        invalidAge={invalidAge(athleteBirthdate)}
        incompleteAnthropometry={incompleteAnthropometry}
        missingSex={missingSex}
        teamId={teamId || ""}
      />
    </Dialog>
  );
};
